import React from 'react'

import { ZariContext } from '_zari/context'
import { Portlet } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import { IdGen } from 'utils'

import * as ComprasService from 'services/compra.service'

import NuevaMainForm from './mainForm'

const ComprasNuevaPage = ({ location, match }) => {
  const __zariContext = React.useContext(ZariContext)

  const [__keyMainForm, setKeyMainForm] = React.useState(null)

  const editarDataRef = React.useRef({})

  const codigoTransaccion = React.useMemo(() => {
    const splitedUrl = location.pathname.split('/')
    const transaccionAndQuery = splitedUrl[1].split('?')
    const transaccion = transaccionAndQuery[0]
    return transaccion
  }, [location.pathname])

  const flagPorGuias = React.useMemo(() => {
    return location.pathname.startsWith(`/${CodigosTransaccionesConstant.COMPRASGUIAS_NUEVA}`)
  }, [location.pathname])

  const portletBreadcrumbs = React.useMemo(() => {
    let baseName = 'Compras'
    if (flagPorGuias) {
      baseName += ' Guias'
    }

    if (match.params.id) {
      return [{ name: baseName, path: `/${CodigosTransaccionesConstant.COMPRAS_LISTA}` }, { name: 'Editar' }]
    }
    return [{ name: baseName, path: `/${CodigosTransaccionesConstant.COMPRAS_LISTA}` }, { name: 'Nuevo' }]
  }, [match.params.id, flagPorGuias])

  React.useEffect(() => {
    if (match.params.id) {
      ComprasService.getCompra(match.params.id)
        .then(({ data }) => {
          editarDataRef.current = data
          setKeyMainForm(IdGen.newId())
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      setKeyMainForm(IdGen.newId())
    }
  }, [match.params, __zariContext, location.search])

  return (
    <>
      <Portlet>
        <Portlet.Header title={flagPorGuias ? 'Compras Por Guias' : 'Compras'} breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          {__keyMainForm && (
            <NuevaMainForm
              key={__keyMainForm}
              editarData={editarDataRef.current}
              flagPorGuias={flagPorGuias}
              codigoTransaccion={codigoTransaccion}
            />
          )}
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default ComprasNuevaPage
